// extracted by mini-css-extract-plugin
export default {"container":"index-module--container--lcl2k"};